import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Tooltip from '@/design_system/Tooltip';
import IconWarning from '@/icons/Warning.svg';

const VATNotApplicableWarning = () => (
  <Tooltip
    textAlign="start"
    size="medium"
    content={
      <Trans id="price-with-details.rows.noVATApplied.warning">
        The cost incl. VAT cannot be displayed, due to the operation being cross-border.
      </Trans>
    }
  >
    <Button variant="style-less" className="text-disabled">
      <IconWarning style={{ fontSize: '16px', color: 'var(--color-warning-700)' }} />
    </Button>
  </Tooltip>
);

export default VATNotApplicableWarning;
